module.exports = "/_next/static/images/offline_product_tnc-b5c2342fed9a90226f1ac0ee36c28969.svg";